import { Action } from "redux";

export enum EApiStatus {
  SUCCESS = "SUCCESS",
  ERROR = "ERROR",
  IN_PROGRESS = "IN_PROGRESS",
}

export interface IApiCallStatusAction extends Action {
  payload: {
    apiName: string;
    status: EApiStatus;
  };
}
